"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumFormat = exports.TealiumAction = exports.PAGE_NAME_CONTACT_INFO = exports.CONTACT_INFO_MODAL_TD_BUTTON_PRIMARY = exports.CONTACT_INFO_MODAL_TD_LINK_CLOSE = exports.CONTACT_INFO_MODAL_TD = exports.CONTACT_INFO_BUTTON_CALL_US = void 0;
exports.CONTACT_INFO_BUTTON_CALL_US = 'CONTACT_INFO_BUTTON_CALL_US';
exports.CONTACT_INFO_MODAL_TD = 'CONTACT_INFO_MODAL_TD';
exports.CONTACT_INFO_MODAL_TD_LINK_CLOSE = 'CONTACT_INFO_MODAL_TD_LINK_CLOSE';
exports.CONTACT_INFO_MODAL_TD_BUTTON_PRIMARY = 'CONTACT_INFO_MODAL_TD_BUTTON_PRIMARY';
exports.PAGE_NAME_CONTACT_INFO = 'generic';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CONTINUE"] = "continue";
    TealiumAction["OPEN"] = "open";
    TealiumAction["CLICK"] = "click";
    TealiumAction["CLOSE"] = "close";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["CONTACT_INFO"] = "contactInfobox";
    TealiumComponent["CONTACT_INFO_MODALTD"] = "modal/security";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["CLICK_BUTTON"] = "clickButton";
    TealiumEventAction["CLICK_LINK"] = "clickLink";
    TealiumEventAction["MODAL_SECURITY"] = "securityModal";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=trackingActions.js.map